import { Divider } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import { withSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import WindsorApi from '../api/WindsorApi';
import LoadingIndicator from '../common/LoadingIndicator';
import NoResultsText from '../common/NoResultsText';
import GroupsTable from './GroupsTable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    textFieldInput: {
      paddingTop: 12,
      paddingBottom: 12
    },
    toolbar: {
      marginBottom: 8
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

function groupFilter(group, search) {
  return group.Name.toLowerCase().includes(search);
}

const windsorApi = new WindsorApi();

function GroupsPage() {
  const classes = useStyles({});
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [groups, setGroups] = useState<any>();
  const [lastModified, setLastModified] = useState();

  useEffect(() => {
    windsorApi.getCspGroups().then(resp => {
      setGroups(resp.Groups);
      setLastModified(resp.LastModified);
    });
  }, []);

  function onSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setSearch(event.target.value);
    setPage(0);
  }

  function onPageChange(newPage: number) {
    setPage(newPage);
  }

  const normalizedSearch = search.toLowerCase();

  const filteredGroups = groups && normalizedSearch ? groups.filter(group => groupFilter(group, normalizedSearch)) : groups;

  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h6">Groups</Typography>
        <Typography color="textSecondary">last synced {moment(lastModified).fromNow()}</Typography>
      </div>
      <Divider className={classes.divider} light />
      <div className={classes.toolbar}>
        <TextField
          id="search"
          value={search}
          autoComplete="off"
          fullWidth
          margin="none"
          variant="outlined"
          placeholder="Search by group name"
          inputProps={{ 'aria-label': 'bare', className: classes.textFieldInput }}
          onChange={onSearchChange}
        />
      </div>
      {filteredGroups && filteredGroups.length > 0 && <div>
        <Paper>
          <GroupsTable
            groups={filteredGroups}
            page={page}
            onPageChange={onPageChange}
          />
        </Paper>
      </div>}
      {filteredGroups && filteredGroups.length === 0 && <NoResultsText>No groups matching filter</NoResultsText>}
      <LoadingIndicator loading={!filteredGroups} />
    </div>
  );
};

export default withSnackbar(observer(GroupsPage));
